import { NgModule } from '@angular/core';
import { CharacterCounterDirective } from './character-counter.directive';

@NgModule({
  declarations: [CharacterCounterDirective],
  exports: [CharacterCounterDirective]
})
export class CharacterCounterModule {}
